import axios from 'axios'
import Qs from 'qs'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  withCredentials: false, // 跨域请求时发送 cookies, default: false
  timeout: 10000, // request timeout
  responseType: 'json', // default
  maxContentLength: 2000,
  maxRedirects: 5, // default
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers.Authorization = sessionStorage.Authorization
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = Qs.stringify(config.data)
    }
    // }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    const status = res.status
    let { code, msg } = res
    code = code || status.code
    msg = msg || status.msg
    if (code !== 200) {
      Message({
        message: msg || 'error',
        type: 'error',
        duration: 5 * 1000
      })
      if (code === 304) {
        MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject(res.message || 'error')
    } else {
      return res
    }
  },
  error => {
    if (error.code === 'ECONNABORTED') {
      // 请求超时
      Message({
        message: '请求超时，请刷新页面再次请求',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

/**
 * @param url {String} 接口URL
 * @param data {Object} 接口请求参数
 */
export const POST = (url, data) => {
  return service({
    url: url,
    method: 'post',
    data: data
    // params: data
  })
}

/**
 * @param url {String} 接口URL
 * @param data {Object} 接口请求参数
 */
export const GET = (url, data) => {
  return service({
    url: url,
    method: 'get',
    params: data
  })
}
